import './page';

import axios from 'axios';
import {geoMercator, geoPath} from 'd3-geo';
import {select, pointer, namespaces} from "d3-selection";
import * as topojson from 'topojson-client';
import $ from 'swiper/esm/utils/dom';
import {click, data, width} from 'dom7/dom7.esm';
$.fn['click'] = click;
$.fn['data'] = data;
$.fn['width'] = width;

let internals = {
    init: function () {
        $('.map__link').on('click', function (e) {
            e.preventDefault();
            internals.draw($(this).data('map'), $(this).data('center'), $(this).data('rotate'));
        });

        $('.map__link:first-child').click();
    },
    draw: function (mapDataUrl, center, rotate) {
        axios.get(mapDataUrl).then(
            response => {
                internals.drawMap(response.data, JSON.parse(center), JSON.parse(rotate));
            }
        );
    },
    drawMap: function (json, center, rotate) {
        let width = Math.min($('#map').width(), 800);
        let height = width * 3 / 4;
        let projection = geoMercator()
            .center(center)
            .rotate(rotate)
            .translate([0, 0])
            .scale(1);

        //Define path generator
        let path = geoPath().projection(projection);

        //Create a fake bounds layer
        let boundsCollection = {
            type: "FeatureCollection",
            features: []
        }

        for (let key in json.map.objects) {
            if (json.map.objects.hasOwnProperty(key)) {
                // Topojson unpacks one layer at a time
                let layer = json.map.objects[key];
                let geojson = topojson.feature(json.map, layer);
                boundsCollection.features = boundsCollection.features.concat(geojson.features);
            }
        }

        // Calculate bounding box transforms for entire collection
        let b = path.bounds(boundsCollection);
        let s = .95 / Math.max((b[1][0] - b[0][0]) / width, (b[1][1] - b[0][1]) / height);
        let t = [(width - s * (b[1][0] + b[0][0])) / 2, (height - s * (b[1][1] + b[0][1])) / 2];

        // Update the projection
        projection.scale(s).translate(t);

        let map = document.getElementById('map');
        map.innerHTML = '';

        let div = document.createElement('div');
        div.classList.add('map__tooltip');
        map.append(div);

        //Create SVG element
        let svg = select("#map")
            .attr("style", "width: " + width + "px")
            .append("svg")
            .attr('class', 'map')
            .attr("width", width)
            .attr("height", height);

        // Bind data and create one path per GeoJSON feature
        svg.selectAll("path")
            .data(boundsCollection.features)
            .enter()
            .append("path")
            .attr("d", path)
            .attr("class", "map__region")
            .on("mouseover", function (e, d) {
                let centroid = path.centroid(d),
                    x = centroid[0],
                    y = centroid[1];
                div.classList.add('map__tooltip--active');
                div.innerHTML = d.properties.geounit;
                div.style.left = (x - div.clientWidth / 2) + "px";
                div.style.top = (y - div.clientHeight / 2) + "px";
            })
            .on("mouseout", function () {
                div.classList.remove('map__tooltip--active');
            });

        select("#map").selectAll('.map__contact')
            .data(json.contacts)
            .enter()
            .append('div')
            .html(function (d) {
               return d.html;
            });

        let city = svg.selectAll("g.map__city")
            .data(json.contacts)
            .enter()
            .append("g")
            .attr("class", "map__city")
            .attr("transform", function (d) {
                return "translate(" + projection([d.lon, d.lat]) + ")";
            })
            .on("mouseover", function (e, d) {
                let contact = document.getElementById('contact_' + d.id);
                contact.classList.add('map__contact--active');
                let p = pointer(e, select('.map__wrap').node());
                contact.style.left = (p[0] ) + "px";
                contact.style.top = (p[1] - contact.clientHeight) + "px";
            })
            .on("mouseout", function (e, d) {
                let contact = document.getElementById('contact_' + d.id);
                contact.classList.remove('map__contact--active');
            });

        city.append("path")
            .attr("d", 'M26 9.32454L16 6L6 9.32454V23.6755L16 27L26 23.6755V9.32454Z')
            .attr("class", function (d) {
                return "map__marker map__marker--" + d.type
            })
            .attr("transform", "translate(-16, -16)");

        city.append(function (d) {
            if (d.type === 'headquarters') {
                let node = select(document.createElementNS(namespaces.svg,'g'));
                node.attr('transform', "translate(0, -30)");
                node.append('path')
                    .attr('fill', '#fff')
                    .attr('d', 'M29.642 0.913c0.175-0.659-0.13-1.099-0.582-0.836l-28.426 16.434c-0.35 0.203-0.633 0.745-0.633 1.21v13.724c0 0.467 0.283 0.681 0.633 0.479l28.426-16.433c0.453-0.262 0.757-1.055 0.582-1.51l-1.861-4.505c-0.192-0.499-0.192-1.187 0-1.906l1.861-6.657z');
                node.append('path')
                    .attr('fill', '#ea5750')
                    .attr('d', 'M9.129 20.956c0 0.333-0.053 1.001-0.549 1.294s-0.55-0.312-0.55-0.646v-2.497c0-0.333 0.053-0.994 0.549-1.285 0.495-0.294 0.55 0.306 0.55 0.638v2.497zM8.573 16.336c-1.599 0.942-2.026 2.926-2.026 4.023v1.742c0 1.986 0.967 2.257 2.033 1.63 1.657-0.976 2.032-2.961 2.032-4.025v-1.744c0-1.155-0.44-2.569-2.039-1.626z');
                node.append('path')
                    .attr('fill', '#ea5750')
                    .attr('d', 'M19.202 15.023c0 0.332-0.053 1.002-0.549 1.293-0.496 0.293-0.549-0.312-0.549-0.645v-2.496c0-0.334 0.052-0.994 0.549-1.286s0.55 0.305 0.55 0.638v2.497zM18.646 10.402c-1.599 0.942-2.025 2.928-2.025 4.022v1.743c0 1.986 0.967 2.258 2.032 1.63 1.655-0.976 2.031-2.961 2.031-4.024v-1.744c0-1.155-0.44-2.569-2.039-1.627z');
                node.append('path')
                    .attr('fill', '#ea5750')
                    .attr('d', 'M4.232 24.313l0.922-0.543c0.382-0.225 0.706-0.097 0.706 0.48 0 0.629-0.385 1.122-0.706 1.311 0-0-1.087 0.64-1.664 0.981-0.577 0.338-0.705-0.212-0.705-0.527v-5.231c0-0.464 0.209-1.065 0.705-1.359 0.654-0.361 0.742 0.223 0.742 0.506v4.381z');
                node.append('path')
                    .attr('fill', '#ea5750')
                    .attr('d', 'M15.046 15.727l-0.663 0.391c-0.178 0.105-0.684 0.478-0.684 1.156 0 0.534 0.307 0.571 0.594 0.402l0.098-0.057v0.236c0 0.747-0.273 1.131-0.602 1.324-0.382 0.227-0.64 0.153-0.64-0.592v-2.497c0-0.334 0.063-1 0.549-1.287 0.451-0.266 0.497 0.098 0.653 0.269 0.155 0.171 0.338 0.111 0.478 0.026 0.24-0.14 0.903-0.84 0.526-1.747-0.116-0.224-0.444-0.752-1.698-0.012-1.439 0.847-1.991 2.678-1.991 4.001v1.743c0 2.12 1.079 2.192 2.050 1.62 1.409-0.786 1.924-2.504 1.924-3.194 0-0.121 0-1.34 0-1.34 0-0.674-0.416-0.548-0.593-0.444z');
                node.append('path')
                    .attr('fill', '#ea5750')
                    .attr('d', 'M23.406 15.087c-1.231 0.675-1.625 0.108-1.703-0.027-0.232-0.403-0.054-0.909 0.069-1.127 0.405-0.64 0.804-0.62 1.002-0.426 0.227 0.199 0.827 0.32 1.21-0.481 0.298-0.731-0.126-0.903-0.636-0.933-0.714-0.040-1.753 0.201-1.753-1.323 0-1.409 0.988-2.727 1.923-3.241 0.748-0.41 1.118-0.27 1.254-0.205s0.242 0.168 0.314 0.306c0.228 0.406 0.047 0.93-0.074 1.149-0.153 0.271-0.511 0.625-0.774 0.541-0.073-0.034-0.138-0.091-0.194-0.179-0.040-0.066-0.18-0.389-0.584-0.167-0.27 0.148-0.578 0.438-0.578 1.007 0 0.522 0.432 0.474 1.017 0.463 0.746 0.017 1.458 0.238 1.458 1.269 0 2.022-1.664 3.218-1.949 3.374z');

                return node.node();
            }
            return select(document.createElementNS(namespaces.svg,'g')).node();
        });
    }
};

internals.init();
